var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfImg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 144,
    viewBox: "0 0 201 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1464_4365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.333 124C129.052 124 152.333 100.719 152.333 72C152.333 43.2812 129.052 20 100.333 20C71.6145 20 48.3333 43.2812 48.3333 72C48.3333 100.719 71.6145 124 100.333 124Z",
    fill: "#38A6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.156 67.8347C120.936 70.3453 120.962 74.4194 118.209 76.956C115.368 79.5795 111.103 83.0543 105.265 86.6767C99.8357 90.0472 95.2664 92.1495 91.8959 93.4265C88.2647 94.8077 84.5902 92.662 83.8605 88.8484C83.096 84.8785 82.3489 79.2407 82.3489 72.3606C82.3489 65.4806 83.07 59.9991 83.8257 56.0379C84.5641 52.1461 88.3429 50.0005 92.0262 51.4599C95.388 52.789 99.9052 54.9173 105.265 58.2444C111.059 61.8408 115.307 65.2547 118.148 67.826L118.156 67.8347Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_4365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(48.3333 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfImg8);
export default __webpack_public_path__ + "static/media/pf_img8.a413eb2a64e48fb52a79e42546d551d5.svg";
export { ForwardRef as ReactComponent };